import { useEffect, useMemo } from 'react';
import {
  V2Gateway_GetServiceAreasForLocationsQueryHookResult,
  useV2Gateway_GetServiceAreasForLocationsLazyQuery,
} from 'Generated/graphql';

export type ServiceAreas = NonNullable<
  V2Gateway_GetServiceAreasForLocationsQueryHookResult['data']
>['getServiceAreasByLocationUid']

const useServiceAreasForLocation = (
  locationUid: string | undefined,
): [
  ServiceAreas | undefined,
  () => void
] => {
  const [getServiceAreasForLocations, getServiceAreasForLocationsQuery] =
    useV2Gateway_GetServiceAreasForLocationsLazyQuery();

  useEffect(() => {
    if (locationUid) {
      getServiceAreasForLocations({
        variables: {
          locationUids: [locationUid],
        },
        fetchPolicy: 'cache-and-network',
      });
    }
  }, [locationUid]);

  const areas = useMemo(() => {
    const { data } = getServiceAreasForLocationsQuery;
    if (data?.getServiceAreasByLocationUid) {
      return data.getServiceAreasByLocationUid;
    }
  }, [getServiceAreasForLocationsQuery.data]);

  return [areas, () => getServiceAreasForLocationsQuery.refetch()];
};

export default useServiceAreasForLocation;

